// Tomado de https://onthecode.co.uk/force-selection-angular-material-autocomplete/

import { AbstractControl } from "@angular/forms";

export function RequireMatch(control: AbstractControl) {
  const selection: any = control.value;
  if (typeof selection === "string") {
    return { incorrect: true };
  }
  return null;
}



// WEBPACK FOOTER //
// ./src/app/components/cliente/registro-cliente/direccion-cliente/requireMatch.ts